import { useTranslation } from 'react-i18next';
import { profile } from '../../content/profile.js';
import { LocaleSelect } from './LocaleSelect.js';

export function Footer() {
  const { t } = useTranslation(['common']);

  return (
    <footer className="footer">
      <div className="footer__text">
        <div className="footer__credit">
          <span>{t('common:footer.rights')}</span>
          <span>{t('common:footer.photography', { photographer: profile.photographyCredit })}</span>
        </div>
        <p className="footer__privacy">{t('common:footer.privacy')}</p>
      </div>
      <LocaleSelect variant="footer" />
    </footer>
  );
}
